module.exports = __webpack_public_path__ + "img/csr_swiper_07.b54551d0.jpg";